/* unplugin-vue-components disabled */import script from "./PrizeValidFormItem.vue?vue&type=script&setup=true&lang=js"
export * from "./PrizeValidFormItem.vue?vue&type=script&setup=true&lang=js"

import "./PrizeValidFormItem.vue?vue&type=style&index=0&id=0c159821&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c159821"]])

export default __exports__